<template>
	<sf-data-table
		ref="table"
		:columns="columns"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		selection
		paging
		@changedPage="onChangePage"
		:currentPage="users.currentPage"
		:pageUnit="users.pageUnit"
		:pageArray="screen.pageArray"
		:totalSize="users.totalSize"
	>
		<template v-slot:actionsLeft>
			<sf-button v-if="isButton_(scrId, 'AD')" line icon="square-plus" :onClick="addAction">
				{{ getMessage_('SWCC000007') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" line icon="file" :onClick="saveAction">
				{{ getMessage_('SWCC000327') }}
			</sf-button>
			<sf-button v-if="isButton_(scrId, 'CD')" line color="error" icon="trash" :onClick="deleteAction">
				{{ getMessage_('SWCC000328') }}
			</sf-button>
		</template>
	</sf-data-table>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/UserManagement/store/helpers';
import * as yup from 'yup';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {},
			rows: [],
			addIndex: 0,
			addRowData: {
				state: 'I',
				userId: null,
				userName: null,
				useYn: 'Y',
				mpassYn: 'Y',
				nouseLockDays: 90,
				pwdExpDays: 180,
				remark: '',
				useYnBk: 'Y',
				email: null
			}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		themeDefault() {
			return process.env.VUE_APP_THEME_DEFAULT;
		},

		schema() {
			return yup.array().of(
				yup.object().shape({
					userId: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000217')])), //{0}은(는) 팔수 입력 값 입니다. , 사용자 권한 그룹 코드
					userName: yup
						.string()
						.nullable()
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000218')])), //{0}은(는) 팔수 입력 값 입니다. , 사용자 권한 그룹 코드
					email: yup
						.string()
						.nullable()
						// 잘못된 이메일형식입니다. (영문 소문자, 대문자, 숫자, -, ., _만 사용가능합니다.) 단, 특수문자( -, ., _ )는 주소 앞뒤로 사용할 수 없습니다.
						.matches(/^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])+@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])+\.[A-Za-z]{2,3}$/, this.getMessage_('SWCC000757'))
						.required(this.$sf_formatString(this.getMessage_('SWCC000116'), [this.getMessage_('SWCC000406')]))
				})
			);
		},
		columns() {
			return [
				{
					label: this.getMessage_('SWCC000217'),
					prop: 'userId',
					minWidth: '150px',
					form: {
						type: 'input',
						maxLength: 20,
						isDisabled: this.isDisabled,
						validation: {
							regExp: /^[A-Z0-9]*$/
						},
						placeholder: this.getMessage_('SWCC000950')
					}
				},
				{
					label: this.getMessage_('SWCC000218'),
					prop: 'userName',
					minWidth: '170px',
					form: {
						type: 'input',
						maxLength: 100
					}
				},
				{
					label: this.getMessage_('QWCC000066'), //사용자 구분 2022-07-21 snjung
					prop: 'employeeType',
					minWidth: '170px',
					form: {
						type: 'select',
						options: this.employeeTypeOptions
					}
				},
				{
					label: this.getMessage_('QWCC000049'), //부서 2022-07-21 snjung
					prop: 'deptCd',
					minWidth: '170px',
					form: {
						type: 'select',
						options: this.deptCdOptions
					}
				},				
				{
					label: this.getMessage_('SWCC000106'),
					prop: 'useYn',
					minWidth: '90px',
					form: {
						type: 'select',
						options: this.useYnOptions
					}
				},
				{
					label: this.getMessage_('QWCC002105'),
					prop: 'mpassYn',
					minWidth: '120px',
					form: {
						type: 'select',
						options: this.useYnOptions
					}
				},
				{
					label: this.getMessage_('SWCC000404'), //ID유효기간
					prop: 'nouseLockDays',
					minWidth: '140px',
					form: {
						type: 'number'
					}
				},
				{
					label: this.getMessage_('SWCC000405'), // PW유효기간
					prop: 'pwdExpDays',
					minWidth: '160px',
					form: {
						type: 'number'
					}
				},
				{
					label: this.getMessage_('SWCC000406'), // 이메일
					prop: 'email',
					minWidth: '250px',
					form: {
						type: 'input',
						maxLength: 200
					}
				},
				{
					label: this.getMessage_('SWCC000407'), // 비고
					prop: 'remark',
					minWidth: '150px',
					sortable: false,
					form: {
						type: 'input',
						maxLength: 500
					}
				},
				{
					label: this.getMessage_('SWCC000408'), //최종로그인일시
					prop: 'dLastLoginDt',
					minWidth: '180px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000409'), //최종암호변경일
					prop: 'dLastPwdChgDt',
					minWidth: '180px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000005'), // 등록자
					prop: 'regId',
					minWidth: '150px',
					sortable: false
				},
				{
					label: this.getMessage_('SWCC000004'), // 등록일
					prop: 'dRegDt',
					minWidth: '180px',
					sortable: false
				}				
			];
		}
	},

	watch: {
		'users.data': function (value) {
			this.rows = value;
		}
	},

	methods: {
		...rootMethods,
		...serviceMethods,

		//선택된 Rows 정보
		getSelectedRows() {
			return this.$refs.table.getSelectedRows();
		},

		//페이징 정보 변경 이벤트
		onChangePage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || !prePageUnit) {
				return; //초기 중복 조회 방지.
			}
			this.search({ currentPage: currentPageVal, pageUnit: pageUnitVal });
		},

		//사용자 조회
		search({ currentPage, pageUnit }) {
			this.$sf_toggleLoading(true);
			this.select_({
				...this.searchParams,
				currentPage,
				pageUnit
			})
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		isDisabled({ column, row, $index }) {
			return row.state !== 'I';
		},

		//테이블 행 추가 버튼 클릭
		addAction() {
			const data = { ...this.addRowData, addIndex: this.addIndex++ };
			this.rows.unshift(data);
			this.$refs.table.getTable().toggleRowSelection(data);
		},

		//저장 버튼 클릭
		saveAction() {
			const selected = this.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				});
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				icon: 'confirm',
				title: this.getMessage_('SWCC000501'), //저장하시겠습니까?
				buttons: [{ title: this.getMessage_('SWCC000103'), clickFn: () => this.save(selected) }] //저장
			});
		},

		//삭제 버튼 클릭
		deleteAction() {
			const selected = this.getSelectedRows();
			const addRows = selected.filter(row => row.state === 'I');
			const deleteRows = selected.filter(row => row.state !== 'I');

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000109'),
					message: this.getMessage_('SWCC000110')
				});

				return;
			} else if (addRows.length === selected.length) {
				this.rows = this.rows.filter(row => {
					if (addRows.findIndex(aRow => aRow.addIndex === row.addIndex) !== -1) return null;
					else return row;
				});
			} else {
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('SWCC000108'),
					buttons: [{ title: this.getMessage_('SWCC000107'), clickFn: () => this.delete(deleteRows) }] //삭제
				});
			}
		},

		//비밀번호 초기화 버튼 클릭
		resetPasswordAction() {
			const selected = this.getSelectedRows();
			const resetRows = selected.filter(row => row.state !== 'I');

			if (resetRows.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('SWCC000110'),
					message: this.getMessage_('SWCC000410')
				}); //비밀번호 초기화 할 데이터를 선택해주세요.
				return;
			}

			this.$sf_showMessage({
				type: 'confirm',
				message: this.getMessage_('SWCC000394'), // 비밀번호를 초기화 하시겠습니까?
				buttons: [{ title: 'Ok', clickFn: () => this.resetPassword(resetRows) }]
			});
		},

		//사용자 정보 저장(추가/수정)
		save(saveRows) {
			try {
				this.schema.validateSync(saveRows);

				const params = saveRows.map(row => ({
					...row,
					useYn: 'N',
					useYn: row.useYn ? row.useYn : 'Y',
					mpassYn: 'N',
					mpassYn: row.mpassYn ? row.mpassYn : 'Y',
					regId: this.user.userId,
					useYnBk: row.useYnBk ? row.useYnBk : 'Y',
					topSkin: this.themeDefault,
					langCd: 'ko_KR',
					userFont: 'HyundaiSans',
					addrType: 'E_MAIL',
					addrContent: row.email
				}));

				this.$sf_toggleLoading(true);
				this.setUsers_(params)
					.then(header => {
						this.$sf_toast({
							...this.$sf_setToastOption(header),
							message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
						});
					})
					.catch(error => {
						this.$sf_toast({ type: 'error', message: error.message });
					})
					.finally(() => {
						this.$sf_toggleLoading(false);
					});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
			}
		},

		//사용자 삭제(미사용 처리)
		async delete(deleteRows) {
			const params = deleteRows.map(row => ({ ...row, useYn: 'N', regId: this.user.userId, addrContent: row.email }));

			this.$sf_toggleLoading(true);
			await this.setUsers_(params)
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		//비밀번호 초기화
		resetPassword(resetRows) {
			const params = resetRows.map(row => ({ userId: row.userId, regId: row.userId }));

			this.$sf_toggleLoading(true);
			this.resetPassword_(params)
				.then(header => {
					this.$sf_toast({
						...this.$sf_setToastOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		}
	}
};
</script>

<style></style>
